import {AfterViewInit, Component, ElementRef, OnChanges, OnDestroy, ViewChild} from "@angular/core";
import {NavigationParams} from "../../orchestration/navigation-params";
import {Page} from "../../orchestration/page";
import {NavigationService} from "../../orchestration/navigation.service";
import {PaymentModel} from "../payment.model";
import {ThreeDSResult} from "../payment";

@Component({
    selector: "woa-adyen-3ds-page",
    templateUrl: "./adyen-3ds-page.component.html",
    providers: [{provide: Page, useExisting: Adyen3dsPageComponent}]
})
export class Adyen3dsPageComponent extends Page implements AfterViewInit, OnChanges, OnDestroy {
    @ViewChild("threeDsHolder") threeDsHolder: ElementRef;

    private action: any;
    private adyenCheckout: any;
    private adyen3ds: any;
    private destroyed: boolean = false;

    constructor(navigationParams: NavigationParams,
                private navigationService: NavigationService,
                public paymentModel: PaymentModel) {
        super();
        this.action = navigationParams.get("action");
    }

    async ngAfterViewInit(): Promise<void> {
        return this.setup();
    }

    async ngOnChanges(): Promise<void> {
        return this.setup();
    }

    ngOnDestroy(): void {
        this.destroyed = true;
    }

    onDidDismissPage(): void {
        if (this.adyen3ds) {
            this.adyen3ds.unmount();
        }
    }

    async setup(): Promise<void> {
        if (this.destroyed || !this.paymentModel.paymentPlatformPublicKey || !this.threeDsHolder) {
            return;
        }

        // noinspection JSUnusedGlobalSymbols
        this.adyenCheckout = await (<any>window).AdyenWeb.AdyenCheckout({
            clientKey: this.paymentModel.paymentPlatformPublicKey,
            environment: this.paymentModel.paymentPlatformLiveMode ? "live-au" : "test",
            locale: "en_US",
            countryCode: "AU",
            onAdditionalDetails: (state: any) => this.navigationService.dismissPage(this, new ThreeDSResult(true, btoa(JSON.stringify(state.data))))
        });
        // noinspection JSUnusedGlobalSymbols
        this.adyen3ds = this.adyenCheckout.createFromAction(this.action, {
            challengeWindowSize: "05"
        }).mount(this.threeDsHolder.nativeElement);
    }
}



// WEBPACK FOOTER //
// ./src/app/payment/adyen-3ds-page/adyen-3ds-page.component.ts